import { html, Page } from 'rune-ts';
import { ProductRankingBody, ProductRankingPageData } from './views/ProductRankingBody/ProductRankingBody';
import klass from './ProductRankingPage.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { FloatingButton_recent_product } from '../../components/cells/FloatingBox/FloatingButtons/FloatingButton_recent_product';
import { FloatingBox } from '../../components/cells/FloatingBox/FloatingBox';

/**
 * 홈 > 상품 랭킹
 */
export class ProductRankingPage extends Page<ProductRankingPageData> {
  protected override template() {
    const { layout_options } = this.data;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body: new ProductRankingBody(this.data),
            footer_data: { ...footer_links, is_mobile: layout_options.is_mobile, lang: ET.lang },
          },
          {
            require_top_arrow_button: true,
            has_bottom_tab_bar: true,
            floating_box: {
              recent_product: FloatingButton_recent_product.makeProps(this.data.recent_product),
              async renderHook(view: FloatingBox) {
                await FloatingBox.refreshRecentProductFloatingButton(view);
              },
            },
            ...layout_options,
            full_width: true,
            selected_bottom_tab_idx: -1,
          },
        )}
      </div>
    `;
  }
}
